let bannedList = [
  "6a4c0d5962f6ece3dd5ed04b78d8daf7143bd7630854e96b0173c296f2772cc6",
  "82c74c1d0743c0895b292709db84fbceedfe7b750e6f24eb21c598c51fbf1f9d",
  "8eea02e8912085962a930b28beed2683a988614de9a339750ae0b3061e2c6db1",
  "eb8d73d31477612d3db55719b1705d57192e89292efd0b214c4f8ca49d04b3ac",
  "ccd96598fbc000ebc67ceb271ce2c49d4d96a8c04c6a874eb0766edd581a182d",
  "2179b3eb258849baaeeb94b59714ec0f16ec5e5857797f90047562b5981e3b29",
  "16a610e176fb1c29821ebd96ec606de838de0214431f6ac11037118916335bb8",
  "ed2be6b2c9d5ec861c256122718078bde659232e6703a59b0752af1e6ab00b52",
  "34f3d374cdce4932025be93ead9c5d21e0856f089a889c8be8bf73c46e726a25",
  "ba78e4d422c0f0407491f1eafeda270a3fb25bf6ba44abfddb03be6e4e591fac",
  "83defd069b1e0399d9bb9b3db2c9676a8e3b89d13b2f1ffc2fcc51f845cb69da",
  "f673bfd9476f3369f88ec49e6f2d9f451d3ad8cb94093ffd7cc1407940dc4844",
  "676c02247668d5b18479be3d1a80933044256f3fbd03640a8c234684e641b6d6",
  "e42dd2a2a88c04413bea0b52a33eb8d5a609f5e22640050ea7f92282eeddb96f",
  "174a7311876f38d317a3c4f8156b8f97fac1e900b557af4ff0474da2f735f415",
  "10f074e8b969cdeacefcab237e102983de7987421ed3e61e1bc822e346423506",
  "f3df9bc0aaab66ee2177b6b759088e0935da0ea91288d14667727903a95119eb",
  "621bbd2f4126b80c5fe75f3fe6d258de1c7836fb3f62b062227dae2096b36d7e",
  "7467e29a0be07a55b8131c478ff39f866034fbda71d410ddcd3b25b2ed962984",
  "f0401bd505fb7dcbb6f1a98d7e85e1e3d4b44e64c2b281220f6d15988805657a",
  "09a1b7aa2e2b80516d11c081d91d2d3585616e0acb7903ab090e8c0ef20a361e",
  "804a5383db1d0278e32351443ca40f4ce34b00cc318a84e51f709b305247a0e4",
  "131688a59b34c4c1c55637ed22a5f6fdbf2245c4d1cdffc1983c667c9ceb9d30",
  "9abc24ada972f84b8e5c4695bafccc5a1d85c0c7429519c3ebf34e7b1e56b48b",
  "acb9956c59c052cfe4501e11fc675abfee3586c561de48c9c5983c73b2d42453",
  "e869a322bd466a08538dc9941387b89df6a956df77f540217a9da098e73b29c5",
  "5efdc05bfec4eca7937713f03286c840448ed84410ad79ab0785eddfe0f285ae",
  "dd296c40170e0d8ee1f8cd96dfe78f9e9dd98cc83d17be90be993837367d6d3e",
  "91688b521b34da93a29168786f4f3d3b5bc6562d22fa35a05d02dabe44ef9b1f",
  "0b06175efc6119df95554f81b2c6619827d62cdf24fe12b23a7e414cc9da0aff",
  "261a46f555c1f47a2c37bccd3456cf940a2dc7fdfa54854f2ed7db8d00fd10a9",
  "e826f9fc7283d8ff230903a36c9fdb47a806648ed9ea2d658d5ddcf010f6f93c",
  "d808952289cad4834312434aae905d327c75d46fab32c65f4cd7233e595a5d3f",
  "03e80da4712068f4c548c2750ac4f2641c6b310496d0a5b0a070befc67fe7593",
  "2f52e0e198ed5dd38e6d20262786f3fb0143817756a9aa68918eead7f683e91c",
  "346fbbef427c8407ef2d457866281b9720e14415a61a58b96bbfb3289a3081e3",
  "426b651bb3932a869a30a725812e51c1a59f62d52849199d94a6fa1e3b2bf77e",
  "fad73cc9109f48d58101e2d0e17291c0b17a200639dd1202dcfd96842cd28f4e",
  "744e24b492d4d211f0fe8a63245e271312403dbdbc1ee6f096d20b051d69fc4f",
  "fad73cc9109f48d58101e2d0e17291c0b17a200639dd1202dcfd96842cd28f4e",
  "03e80da4712068f4c548c2750ac4f2641c6b310496d0a5b0a070befc67fe7593",
  "b61b131e15d677cb7737dabf55cbb5d8a7b54373de63e194a6d29917bd0b48cc",
  "426b651bb3932a869a30a725812e51c1a59f62d52849199d94a6fa1e3b2bf77e",
  "346fbbef427c8407ef2d457866281b9720e14415a61a58b96bbfb3289a3081e3",
  "2f52e0e198ed5dd38e6d20262786f3fb0143817756a9aa68918eead7f683e91c",
  "913786fdd14a8b9e3df03c8e225433819780fca864af6eb3eff1e8f22b038c1e",
  "64de4e339f03bdad853c47026ef0d80b37bc781c6f2af050041340da20fad093",
  "744e24b492d4d211f0fe8a63245e271312403dbdbc1ee6f096d20b051d69fc4f",
  "b6d14afed050bfea8222c56e471afa67b50bf1171995a157785763eeb2af5b0d",
  "76c439b088bcdffa90dc0b23276c0a9b33148a3c4c58bbb622384c76359e7f4e"
];
export default bannedList;
